import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layouts'
import Progress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes,
})

router.beforeEach((to, from, next) => {
  Progress.start()
  next()
})

router.afterEach(() => {
  Progress.done()
})

export default router
